import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiHelperService } from '../api-helper-service/api-helper.service';
import { GlobalService } from '../global/global.service';
import { StorageService } from '../storage/storage.service';
import { UserType } from 'src/app/enums/user';
import { booleanObjectType } from 'aws-sdk/clients/iam';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  userType: UserType; // for menu logic checking

  constructor(
    private globalService: GlobalService,
    private apiHelperService: ApiHelperService,
    private storage: StorageService
  ) { }

  getUserId(): Promise<number> {
    return new Promise(async (resolve, reject) => {
      const user = await this.storage.get('user');
      console.log('user info', user);
      resolve(user.userId);
    });
  }
  getUsernric(): Promise<number> {
    return new Promise(async (resolve, reject) => {
      const user = await this.storage.get('user');
      resolve(user.identityNo);
    });
  }

  getUserType(): Promise<string> {
    return new Promise(async (resolve, reject) => {
      const user = await this.storage.get('user');
      console.log('user info', user);
      resolve(user.userType);
    });
  }

  getAgentCode(): Promise<string> {
    return new Promise(async (resolve, reject) => {
      let user = await this.storage.get('user');
      if (!user) {
        user = {
          agentCode: 'ABC2200001'
        };
      }
      resolve(user.agentCode);
    });
  }

  updateChangePasswordRequiredToFalse(): Promise<string> {
    return new Promise(async (resolve, reject) => {
      let user = await this.storage.get('user');
      if (user && user.passwordResetRequired) {
        user.passwordResetRequired = false;
        let userUpdated = await this.storage.set('user',user);
      }
      resolve(user);
    });
  }

  // retreive agent code based on account login
  async getLoggedInAgentUserDetailsByEmail(email: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const searchPayload = {
          filter: JSON.stringify({
            where: {
              email
            },
            fields: ['id', 'userId', 'email', 'agentCode','displayName', 'isActive']
          }),
          referenceNumber: this.globalService.generateUUID(),
          username: this.globalService.username,
          channelId: this.globalService.channelId
        };
        const searchResponse = await this.apiHelperService.retrievedAgentList(searchPayload);
        console.log(searchResponse.data);
        resolve(searchResponse.data.agentList[0]);
      }
      catch (err) {
        reject(err);
      }
    });
  }

  // or by email better?
  async getLoggedInCustomerUserDetailsById(id: string | number): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const searchPayload = {
          filter: JSON.stringify({
            where: {
              identityNo: id
            },
            //tmp add fullName,identityNo
            fields: ['id', 'officeId', 'email','fullName','identityNo','mobileNo', 'passwordResetRequired', 'isBranchAssigned']
          }),
          referenceNumber: this.globalService.generateUUID(),
          username: this.globalService.username,
          channelId: this.globalService.channelId
        };
        const searchResponse = await this.apiHelperService.retrieveClientListing(searchPayload);
        console.log('searchResponse: ', searchResponse);
        resolve(searchResponse.data.user[0]);
      }
      catch (err) {
        reject(err);
      }
    });
  }

  async getUserToken(request): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const searchResponse = await this.apiHelperService.getToken(request);
        console.log('searchResponse: ', searchResponse);
        resolve(searchResponse);
      }
      catch (err) {
        reject(err);
      }
    });
  }

  // store the logged value into storage
  async storeIntoStorage(user: any, userType: UserType) {
    await this.storage.set('user', {
      userType,
      userId: user.userId,
      officeId: user.officeId,
      email: user.email,
      agentCode: user.agentCode,
      displayName: user.displayName,
      //tmp for user only
      fullName : user.fullName,
      identityNo: user.identityNo,
      mobileNo: user.mobileNo,
      passwordResetRequired: user.passwordResetRequired
    });
    this.userType = userType;
  }

 /**
  * @param userType user type
  * @param email user email (for AGENT)
  * @param id user id (for CUSTOMER)
  */
  async initUserSetupAfterSignin(userType: UserType, email: string, id: string | number) {
    let user: any;
    switch (userType) {
      case UserType.AGENT:
        const agentInfo = await this.getLoggedInAgentUserDetailsByEmail(email);
        console.log('agentInfo', agentInfo);
        user = {
          id: agentInfo.id,
          email:email,
          agentCode: agentInfo.agentCode,
          userId: agentInfo.id,
          displayName: agentInfo.displayName
        };
        break;
      case UserType.CUSTOMER:
        const userInfo = await this.getLoggedInCustomerUserDetailsById(id); //added
        console.log('userInfo', userInfo); //added
        user = {
          id,
          email : userInfo.email,
          //tmp use
          userId : userInfo.id,
          fullName : userInfo.fullName,
          identityNo : userInfo.identityNo,
          mobileNo: userInfo.mobileNo,
          isBranchAssigned: userInfo.isBranchAssigned,
          officeId: userInfo.officeId,
          passwordResetRequired: userInfo.passwordResetRequired
        };
        break;
      default:
        console.error('Invalid user type.');
        break;
    }
    console.log('user', user);

    await this.storeIntoStorage(user, userType);
    this.globalService.username = email;
  }

  async checkStorageAndLogin() {
    const currentUser = await this.storage.get('user');
    console.log(currentUser);
    return (currentUser);
  }

  async getUserStorage() {
    const currentUser = await this.storage.get('user');
    return currentUser;
  }

  getUserTypeList(): DropdownListObject[] {
    return [
      { name: 'userType.agent', value: UserType.AGENT },
      { name: 'userType.customer', value: UserType.CUSTOMER }
    ];
  }

}

interface DropdownListObject {
  name: string;
  value: string;
}
